import React from 'react'
import CopyTextLink from 'src/components/CopyTextLink/CopyTextLink'
import SvgCopy from 'src/components/Svgs/SvgCopy'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface CopyableKeyDisplayProps {
  text: string
  copyEnabled: boolean
}

const CopyableKeyDisplay: React.FC<CopyableKeyDisplayProps> = ({
  text,
  copyEnabled,
}) => {
  return (
    <div
      css={css`
        padding: 16px 20px;
        display: flex;
        width: 100%;
        align-items: center;
        background-color: #fcfcff;
        border-radius: 6px 6px 6px 6px;
        border-color: #eaebf1;
        border-width: 1px;
        border-style: solid;
      `}
    >
      <span
        css={css`
          white-space: normal;
          max-width: 500px;
          overflow: hidden;
          text-overflow: ellipsis;
          flex-grow: 1;
          word-break: break-word;
          font-family: ${copyEnabled ? 'monospace' : 'inherit'};
        `}
      >
        {text}
      </span>
      {copyEnabled && (
        <CopyTextLink
          css={css`
            margin-left: 10px;
          `}
          copyValue={text}
          copyText={
            <>
              <SvgCopy
                css={css`
                  transform: scale(0.6);
                `}
              />
              <Trns source={'Copy'} />
            </>
          }
        />
      )}
    </div>
  )
}

export default CopyableKeyDisplay
